import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { savePerformanceAreas } from '../../../store/ducks/user';
import SettingsContainer from '../../../components/settings-container';
import MultiSelect from '../../../components/multi-select';

const selectOptions = [
  {
    optionText: 'Speed',
    optionValue: 'speed'
  },
  {
    optionText: 'Endurance',
    optionValue: 'endurance'
  },
  {
    optionText: 'Agility',
    optionValue: 'agility'
  },
  {
    optionText: 'Hill climbing',
    optionValue: 'hillclimbing'
  }
];

export class PurePerformanceAreas extends Component {
  state = {
    performanceAreas: this.props.initialValue
  };

  save = async () => {
    try {
      await this.props.savePerformanceAreas(this.state.performanceAreas);
    } catch (e) {
      /* do nothing */
    }
  }

  getActiveOptions = () => {
    const findIndex = (performanceArea) => {
      return selectOptions.findIndex(({ optionValue }) => optionValue === performanceArea);
    };
    return this.state.performanceAreas.map(findIndex);
  }

  setPerformanceAreas = (activeOptions) => {
    const performanceAreas = [];
    activeOptions.forEach((idx) => {
      performanceAreas.push(selectOptions[idx].optionValue);
    });
    this.setState({ performanceAreas });
  }

  render() {
    return (
      <SettingsContainer
        save={ this.save }
        className="performance-area-page"
        pageTitle="Select the areas you’d like to improve performance on."
        subtitle
        isValid={ Boolean(this.state.performanceAreas.length) }
      >
        <MultiSelect
          selectOptions={ selectOptions }
          initialValue={ this.getActiveOptions() }
          setActiveOptions={ this.setPerformanceAreas }
        />
      </SettingsContainer>
    );
  }
}

PurePerformanceAreas.propTypes = {
  initialValue: PropTypes.array.isRequired,
  savePerformanceAreas: PropTypes.func.isRequired
};

PurePerformanceAreas.defaultProps = {
  initialValue: []
};

export default connect(
  state => ({
    initialValue: state.user.performance_goals
  }),
  dispatch => ({
    savePerformanceAreas: performanceAreas => dispatch(savePerformanceAreas(performanceAreas))
  }),
  null,
  { withRef: true }
)(PurePerformanceAreas);
